import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';
import { TraceResponse, ITracesService } from './traces.interface';

@Injectable({
  providedIn: 'root'
})
export class TracesService implements ITracesService {
  constructor(private httpClient: HttpClient) { }

  getTraces(from: Date, to: Date, limit = 100, page = 0, order = 'ASC'): Observable<TraceResponse> {
    // dates as 2024-01-01T00:00:00
    return this.httpClient.get<TraceResponse>(environment.apiPrivateUrl + '/traces?from='+ from.toISOString() + '&to=' + to.toISOString() + '&limit=' + limit + '&page=' + page + '&order=' + order + '&language=' + LanguageUtils.getLanguage());
  }
}
